import { ThanhToanHDContext } from "../ThanhToanHD";
import InputSearch from "../../../../component/InputSearch";
import { FC, useContext, useEffect, useLayoutEffect, useState } from "react";
import { AppContext } from "../../../../appContext/AppContext";
import DanhSachPhieu from "../../../../component/DanhSachPhieu";
import { initialValuesFormThanhToanHD, ThongTinThanhToanHDColumns } from "../ThanhToanHDConstant";
import { createReceiptHD, getInfoPayment, getListReceiptHD } from "../../../services/ThanhToanHopDongServices";
import { formatDateDTO, formatDateToYYYYMMDD, formatMoney } from "../../../../utils/FormatUtils";
import { INV_TYPE_CODE } from "../../../../phan-he-vien-phi/const/VienPhiConstant";
import { Form, FormCheck } from "react-bootstrap";
import PhieuThanhToanHD from "./PhieuThanhToanHD";
import { Formik } from "formik";
import * as Yup from "yup";
import { useIntl } from "react-intl";
import { CODE } from "../../../../utils/Constant";
import { toast } from "react-toastify";
import { TableCollapseCustom } from "../../../../component/table/table-collapse/TableCollapseCustom";
import clsx from "clsx";

const ThongTinThanhToanHD: FC<any> = (props) => {
  const { HDSelected, DSGoiKham, setDSGoiKham } = useContext(ThanhToanHDContext);
  const { setIsLoading } = useContext(AppContext);
  const intl = useIntl();
  const [openPhieuThu, setOpenPhieuThu] = useState(false);
  const [listDanhSachPhieu, setListDanhSachPhieu] = useState([]);
  const [initialValues, setInitialValues] = useState<any>(initialValuesFormThanhToanHD);
  const [thongTinThanhToan, setThongTinThanhToan] = useState<any>();
  const [onlyView, setOnlyView] = useState<boolean>(false);
  const [onlyViewInvTotal, setOnlyViewInvTotal] = useState<boolean>(false);
  const [listGKClone, setListGKClone] = useState<any[]>([]);

  const validationSchema = Yup.object({
    loaiPhieu: Yup.object().nullable().required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' })),
    hinhThuc: Yup.object().nullable().required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' })),
    invTotal: Yup.number().typeError("Vui lòng nhập số").required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' })),
  });

  const handleCheck = (checked: boolean, row: any, index: number) => {
    const newListGoiKham = [...DSGoiKham];
    newListGoiKham[index].checked = checked;
    const newArr = handleConverDataGoiKham(newListGoiKham);
    setDSGoiKham(newArr);
  };

  const handleSelectPhieuThanhToan = (item: any) => {
    setOpenPhieuThu(true);
    setOnlyView(true);
    setInitialValues(item);
  };

  const updateDSGoiKham = async () => {
    try {
      setIsLoading(true);
      const { data } = await getInfoPayment(HDSelected?.id);

      if (CODE.SUCCESS === data?.code && data?.data) {
        const { paymentPackage, ...paymentInfo } = data.data;
        const newListGK = paymentPackage?.map((item: any) => {
          const isPaidPackage = item?.feePackage === item?.totalFeePaid;

          return {
            ...item,
            nameGK: item?.name,
            terms: item?.terms?.map((term: any) => {
              return {
                ...term,
                quantity: item?.quantity,
                totalFeePaid: isPaidPackage ? term.feePackage : 0,
              }
            })
          }
        });
        const listGoiKham = handleConverDataGoiKham(newListGK);
        setListGKClone(newListGK);
        setDSGoiKham(listGoiKham || []);
        setThongTinThanhToan(paymentInfo);
    }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConverDataGoiKham = (data: any) => {
    const listGoiKham = data?.map(
      (item: any, index: number) => {
        const isPaidPackage = item?.feePackage === item?.totalFeePaid;

        return {
          ...item,
          nameGK: item?.nameGK,
          name: (
            <span className="d-flex gap-4 spaces pl-4">
              {onlyViewInvTotal ? (
                <Form className="d-flex align-items-center">
                  <FormCheck
                    type="checkbox"
                    label=""
                    checked={item?.checked || isPaidPackage}
                    className="mgr-3 form-check check-box-vp flex-1"
                    onChange={(e) => handleCheck(e.target.checked, item, index)}
                    disabled={isPaidPackage}
                  />
                </Form>
              ) : (
                <></>
              )}
              <span>{item.name}</span>
            </span>
          )
        }
      }
    );
    return listGoiKham;
  }

  const updateListReceiptHD = async () => {
    try {
      setIsLoading(true);
      const { data } = await getListReceiptHD(HDSelected.id);
      const dsPhieuThu = data?.data?.map((item: any) => {
        return {
          ...item,
          invDate: formatDateToYYYYMMDD(item.invDate),
          price: `(${item.invTypeCode !== INV_TYPE_CODE.PHIEU_HOAN.code ? '+' : '-'}) ${formatMoney(item?.invTotal)}`,
          hinhThuc: {
            id: item.invHinhThucId,
            name: item.invHinhThucName,
          },
          loaiPhieu: {
            id: item.invTypeId,
            code: item.invTypeCode,
            name: item.invTypeName,
          },
        }
      });
      setListDanhSachPhieu(dsPhieuThu || [])
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (HDSelected?.id) {
      updateDSGoiKham();
      updateListReceiptHD();
      setOnlyView(false);
      setInitialValues(initialValuesFormThanhToanHD);
    }
  }, [HDSelected?.id]);

  useEffect(() => {
    setOnlyViewInvTotal(false);
    setInitialValues({...initialValuesFormThanhToanHD, invDate: new Date()});
  }, [HDSelected])

  useLayoutEffect(() => {
    if (onlyViewInvTotal) {
      const listGoiKham = handleConverDataGoiKham(DSGoiKham);
      setDSGoiKham(listGoiKham);
    }
  }, [onlyViewInvTotal])

  const handleSubmitForm = async (values: any) => {
    if (parseFloat(values?.invTotal) <= 0) {
      toast.warning('Chưa chọn gói khám hoặc số tiền không hợp lệ !');
      return;
    };

    const dataSubmit = {
      ...values,
      contractId: HDSelected.id,
      invDate: formatDateDTO(values?.invDate),
      invTypeId: values?.loaiPhieu?.id,
      invTypeCode: values?.loaiPhieu?.code,
      invTypeName: values?.loaiPhieu?.name,
      invHinhThucId: values?.hinhThuc?.id,
      invHinhThucName: values?.hinhThuc?.name,
      invLedgerId: values?.invLedgerId,
      invCashier: values?.invCashier,
    };
    
    try {
      setIsLoading(true);
      const res = await createReceiptHD(dataSubmit);
      if (CODE.SUCCESS === res?.status) {
        setOpenPhieuThu(false);
        updateListReceiptHD();
        updateDSGoiKham();
        setInitialValues({...initialValuesFormThanhToanHD, invDate: new Date()});
        toast.success('Tạo phiếu thu thành công');
      }
    } catch (error) {
      console.error(error); 
      toast.error('Có lỗi xảy ra, vui lòng thử lại')
    } finally {
      setIsLoading(false);
    }
  };

  return (
		<div className="bg-white">
			<TableCollapseCustom
				columns={ThongTinThanhToanHDColumns}
				data={DSGoiKham || []}
				childrenField="terms"
				parentField="false"
				className={clsx(
					'spaces overflow-auto',
					`${openPhieuThu ? 'h-calc-vh-520': 'h-calc-vh-410'}`
				)}
				startColumn={0}
			/>
			<div className="spaces p-8">
				<DanhSachPhieu
					dsPhieu={HDSelected.id ? listDanhSachPhieu : []}
					handleSelectRowData={handleSelectPhieuThanhToan}
					title="price"
					className="min-vh-52px"
				/>
			</div>
			<div className="spaces pl-10 pr-20 bg-white">
				<Formik
					enableReinitialize
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={(values) => handleSubmitForm(values)}
				>
					<PhieuThanhToanHD
						HDSelected={HDSelected}
						openPhieuThu={openPhieuThu}
						setOpenPhieuThu={setOpenPhieuThu}
						onlyView={onlyView}
						setOnlyView={setOnlyView}
						setInitialValues={setInitialValues}
						onlyViewInvTotal={onlyViewInvTotal}
						setOnlyViewInvTotal={setOnlyViewInvTotal}
						thongTinThanhToan={thongTinThanhToan}
						listGKClone={listGKClone}
						listDanhSachPhieu={listDanhSachPhieu}
					/>
				</Formik>
			</div>
		</div>
  );
};

export default ThongTinThanhToanHD;
